import { redirectUnauthedUser } from './redirectUnauthedUser';
import { getAccessToken } from 'src/common/external/aws/getAccessToken';
import { signOut } from 'src/common/external/aws/signOut';

// Single seam for auth actions:
// - signOut: explicit "Sign out" — clears tokens + the Hosted-UI session cookie
//   (via /logout) and lands on the marketing site.
// - redirectUnauthedUser: missing/expired session — bounce to the Hosted UI to
//   (re-)authenticate.
const authService = {
  signOut,
  getAccessToken,
  redirectUnauthedUser,
};

export { authService };
